/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import ChatListItem from '../chatListItem/ChatListItem';
import { useDispatch, useSelector } from 'react-redux';
import fetchConversations from '../../store/actions/conversationActions';
import ReceiveConversationNotifications from '../receiveConversationNotifications/ReceiveConversationNotifications';
import { handleLoader, isNotEmpty } from '../../utils/utilities';

import './ChatList.css';


export default function ChatList(props: any) {
    const [hasMore, setHasMore] = useState(true);
    const selected_conversation = useSelector((state: any) => state.chat.selectedConversation);
    const user = useSelector((state: any) => state.user);
    const chatListRef = useRef<any>();
    const observer: any = useRef();
    const dispatch = useDispatch();
    const allConversations = useSelector((state: any) => {
        return state.chat && state.chat.allConversations;
    })
    const limit = useSelector((state: any) => state.chat.limit);
    const loader = useSelector((state: any) => state.loader.conversationsLoader);
    const selectedAdjuster = useSelector((state: any) => state.adjusters.selectedAdjuster);

    useEffect(() => {
        chatListRef.current.scrollTop = 0;
    }, [props.receivedConversationsCount]);

    useEffect(() => {
        setHasMore(true);
    }, [selectedAdjuster])

    const lastConversationRef = useCallback(node => {
        if (loader?.isLoading || !hasMore) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                handleLoader(true)
                dispatch(fetchConversations({ adjusterId: props.isViewer ? selectedAdjuster.adjusterEmailId : user?.email, isArchived: props.onlyArchived ? true : false }, (res: any) => {
                    if (res.length < limit) {
                        setHasMore(false);
                    }
                    handleLoader(false);
                }))
            }
        })
        if (node) observer.current.observe(node);
    }, [loader?.isLoading])

    const toggleAnimation = (user: any) => {
        // dispatch(formatSelectedConversation(user));
        props.toggleAnimation && props.toggleAnimation();
    }

    return (
        <div
            className={"chat-list " + (props.className || "")}
            data-testid="chat-list"
            ref={chatListRef}
        >
            <>
                {(isNotEmpty(props.receivedConversationsCount) && props.receivedConversationsCount > 0 && 
                <ReceiveConversationNotifications receivedConversationsCount={props.receivedConversationsCount} />)}
                {!props.initialLoad && (allConversations || []).map((item: any, index: number) => {
                    return (
                        <ChatListItem
                            key={item?.conversationId}
                            ref={allConversations.length === index + 1 ? lastConversationRef : null}
                            animationDelay={index + 1}
                            active={selected_conversation ? (item?.conversationId === selected_conversation?.conversationId) : false}
                            conversation={item}
                            index={index}
                            toggleAnimation={toggleAnimation}
                            setReferenceElement={props.setReferenceElement}
                            menuOptions={props.menuOptions}
                        />
                    );
                })}
                {loader?.isLoading &&
                    <div className="loader"></div>}
            </>
        </div>
    )
}
